import React from "react";
import { pluralize } from "@common/helpers/string";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { ReviewerMode } from "../Tabs/ReviewFilter/ReviewerFilterSection";

interface ReviewerFilterLabelProps {
    reviewerIds: number[] | undefined;
    reviewerMode: ReviewerMode | undefined;
}

const REVIEWER_MODE_LABELS: Record<ReviewerMode, string> = {
    all: "All",
    none: "None",
    any: "Any",
};

export const ReviewerFilterLabel: React.FC<ReviewerFilterLabelProps> = ({
    reviewerIds = [],
    reviewerMode = "any",
}) => {
    const { data: members = [] } = useCurrentWorkspaceMembers();
    const modeLabel = REVIEWER_MODE_LABELS[reviewerMode];

    if (reviewerIds.length === 1) {
        const member = members.find((m) => m.user.id === reviewerIds[0]);
        return <>{`${modeLabel}: ${member?.user.name ?? "reviewer"}`}</>;
    }

    return (
        <>{`${modeLabel}: ${reviewerIds.length} ${pluralize("reviewer", reviewerIds.length)}`}</>
    );
};
